import {UIStoreMembershipProductView} from './UIStoreMembershipProductView'
import {UIStoreState} from './UIStoreState'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {TranslationKeys} from '@colonist/i18n'
import {GiftedMembershipItem} from '../../../../shared/store/UserItems'
import {Sound} from '../Sound'
import {CA} from '../analytics/Analytics'
import {ViewPopup} from '../ui_popup/ViewPopup'
import {BigId} from '@colonist/types'
import {TimeUtils} from '@colonist/utils'
import {GIFT_MEMBERSHIP_EXPIRY_YEARS} from '../../../../shared/store/BaseStoreItem'
import {clientI18n} from '../ClientI18n'

export class UIGiftedMembershipProductView extends UIStoreMembershipProductView {
    constructor(container: HTMLDivElement, storeState: UIStoreState, giftedMembership: GiftedMembershipItem, activateMembership: (id: BigId) => Promise<void>, localizedPrice?: string) {
        const membershipProduct = ColonistMembershipProduct.getMembershipProduct(giftedMembership.membershipType)
        const canBeGifted = false
        super(container, storeState, membershipProduct, undefined, localizedPrice)

        setElementInnerHTML(this.priceDiv, {key: getLengthText(membershipProduct.billedAnnually), options: {count: giftedMembership.periods}})

        const expiresAt = TimeUtils.addYears(TimeUtils.toDate(giftedMembership.giftedAt), GIFT_MEMBERSHIP_EXPIRY_YEARS)

        const expiry = TimeUtils.formatDateDistance(new Date(), expiresAt)
        const expiryFormatted = clientI18n.t(expiry.key, expiry.options)

        setElementInnerHTML(this.disclaimerText, {key: 'strings:storePage.sections.membership.giftWithExpiry', options: {expiry: expiryFormatted}})

        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.membership.action.activate'})
        setElementOnClick(this.productDiv, () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedActivate, membershipProduct.type)

            const popup = new ViewPopup({key: 'strings:storePage.sections.membership.activateConfirmation.title'},
                {key: 'strings:storePage.sections.membership.activateConfirmation.body'},
                () => activateMembership(giftedMembership.id),
                () => undefined,
                true)
            popup.show()
        })
    }

    // eslint-disable-next-line class-methods-use-this
    protected addBestValueHint() {
        // no hint
    }
}

function getLengthText(year: boolean): TranslationKeys {
    if(year) return 'strings:colonistCommon.dates.year'
    return 'strings:colonistCommon.dates.month'
}
